import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Polygon } from '../../polygon/polygon';

interface Data {
  citiesCount: any;
  category: string;
  selectedMethod: string;
}

interface Cities {
  hebrew: string;
  english: string;
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './polygon-fetch-cities-dialog.html',
  styleUrls: ['./polygon-fetch-cities-dialog.scss'],
  standalone: false,
})
export class PolygonFetchCitiesDialog implements OnInit {
  polygonCities: any;
  englishCities: string = '';
  nativeCities: string = null;
  showNativeCitiesV: boolean = false;
  showEnglishCitiesV: boolean = false;
  category: string;
  selectedMethod: string;

  constructor(
    public dialogRef: MatDialogRef<Polygon>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
  ) {}

  ngOnInit(): void {
    this.category = this.data.category;
    this.selectedMethod = this.data.selectedMethod;
    this.polygonCities = this.data.citiesCount;
    this.polygonCities.map((city: Cities) => {
      this.englishCities += city?.english + ', ';
      if (city?.hebrew) {
        this.nativeCities += city?.hebrew + ', ';
      }
    });
  }

  onHebrewCities(): void {
    this.showNativeCitiesV = true;
    this.showEnglishCitiesV = false;
  }

  onEnglishCities(): void {
    this.showEnglishCitiesV = true;
    this.showNativeCitiesV = false;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getCitiesStatesStreetsText(): string {
    if (this.selectedMethod.includes('states')) {
      return 'States';
    }
    return this.category == 'local' ? 'Streets' : 'Cities';
  }
}
